import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaChevronRight } from 'react-icons/fa';

const Hero = () => {
  return (
    <section id="home" className="min-h-screen relative flex items-center pt-20 overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-primary/5 to-transparent -z-10" />
      
      <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* Left Column: Text Content */}
        <div className="lg:col-span-7 z-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <span className="inline-block px-4 py-2 rounded-full glass border-white/10 text-accent-cyan text-sm font-medium mb-6">
              Available for Freelance Projects
            </span>
            
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-tight mb-8">
              T.G. <span className="text-gradient">Ravindu</span> <br />
              Maleesha
            </h1>
            
            <h2 className="text-xl md:text-2xl text-white/60 mb-8 max-w-2xl font-light">
              Associate Software Engineer & Full-Stack Developer. 
              <span className="text-white block mt-2 font-medium">"Building high-performance software in all languages."</span>
            </h2>

            <div className="flex flex-wrap gap-6 items-center">
              <motion.button
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="btn-primary flex items-center gap-3 group"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Let's Discuss Your Project
                <FaChevronRight className="group-hover:translate-x-1 transition-transform" />
              </motion.button>
              
              <div className="flex gap-4">
                {[
                  { icon: FaGithub, href: 'https://github.com/rv0627' },
                  { icon: FaLinkedin, href: 'https://www.linkedin.com/in/ravindu-maleesha-598275256/' },
                  { icon: FaEnvelope, href: 'mailto:ravindumaleesha077@gmail.com' }
                ].map((social, i) => (
                  <motion.a
                    key={i}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full glass flex items-center justify-center text-white/50 hover:text-white hover:border-white/20 transition-all"
                    whileHover={{ y: -5 }}
                  >
                    <social.icon size={20} />
                  </motion.a>
                ))}
              </div>
            </div>
          </motion.div>
        </div>

        {/* Right Column: Asymmetrical Image / Abstract Element */}
        <div className="lg:col-span-5 relative">
          <motion.div
            initial={{ opacity: 0, scale: 0.8, rotate: 5 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
            className="relative z-10"
          >
            {/* The Image Container - Asymmetrical Frame */}
            <div className="relative w-full aspect-[4/5] rounded-[2rem] overflow-hidden border border-white/10 glass rotate-3 hover:rotate-0 transition-all duration-700">
              <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent opacity-40 z-10" />
              <img 
                src={process.env.PUBLIC_URL + "/profile.jpg"} 
                alt="Ravindu Maleesha"
                className="w-full h-full object-cover transition-all duration-700"
              />
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-10 -right-10 w-40 h-40 glass rounded-full -z-10 animate-float" />
            <div className="absolute -bottom-10 -left-10 px-8 py-6 glass rounded-2xl z-20 border-white/10 hidden md:block">
              <p className="text-3xl font-bold text-gradient">2026</p>
              <p className="text-xs text-white/50 uppercase tracking-widest">Portfolio Edition</p>
            </div>
          </motion.div>
          
          {/* Subtle Glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-primary/10 blur-[120px] rounded-full -z-10" />
        </div>
      </div>

      {/* Floating Tech Stack - Minimalist */}
      <div className="absolute bottom-10 left-0 w-full overflow-hidden whitespace-nowrap opacity-20 pointer-events-none">
        <div className="inline-block animate-pulse-slow">
          <span className="text-4xl md:text-6xl font-bold mx-10">NEXT.JS</span>
          <span className="text-4xl md:text-6xl font-bold mx-10">LARAVEL</span>
          <span className="text-4xl md:text-6xl font-bold mx-10">MERN</span>
          <span className="text-4xl md:text-6xl font-bold mx-10">PYTHON</span>
          <span className="text-4xl md:text-6xl font-bold mx-10">REACT NATIVE</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;

